export default {
  en: {
    mark_all_as_read: 'Mark all as read',
    show_all: 'Show all',
    error:
      'We are having issues fetching your notifications. Please try again later.',
    empty: 'You have no new notifications!',
    loading: 'Loading...',
    snack: {
      mark_all_as_read_success: 'Notifications read successfully!',
    },
  },
};
